var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBottombarSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6.49994C3.25 4.70501 4.70507 3.24994 6.5 3.24994C8.29493 3.24994 9.75 4.70501 9.75 6.49994C9.75 8.29486 8.29493 9.74994 6.5 9.74994C4.70507 9.74994 3.25 8.29486 3.25 6.49994ZM6.5 4.74994C5.5335 4.74994 4.75 5.53344 4.75 6.49994C4.75 7.46644 5.5335 8.24994 6.5 8.24994C7.4665 8.24994 8.25 7.46644 8.25 6.49994C8.25 5.53344 7.4665 4.74994 6.5 4.74994Z",
    fill: "#00322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4939 3.43552C19.8056 3.70828 19.8372 4.1821 19.5644 4.49383L5.56444 20.4938C5.29168 20.8056 4.81786 20.8371 4.50613 20.5644C4.1944 20.2916 4.16282 19.8178 4.43558 19.5061L18.4356 3.50607C18.7083 3.19434 19.1822 3.16276 19.4939 3.43552Z",
    fill: "#00322E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 14.25C15.7051 14.25 14.25 15.7051 14.25 17.5C14.25 19.2949 15.7051 20.75 17.5 20.75C19.2949 20.75 20.75 19.2949 20.75 17.5C20.75 15.7051 19.2949 14.25 17.5 14.25ZM15.75 17.5C15.75 16.5335 16.5335 15.75 17.5 15.75C18.4665 15.75 19.25 16.5335 19.25 17.5C19.25 18.4665 18.4665 19.25 17.5 19.25C16.5335 19.25 15.75 18.4665 15.75 17.5Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBottombarSales);
export default __webpack_public_path__ + "static/media/icn_bottombar-sales.b1ceff1015c0b1ced82fa7dffc42f4de.svg";
export { ForwardRef as ReactComponent };